import PropTypes from 'prop-types';
import _ from 'underscore';
import React, { useCallback } from 'react';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { Link, PrimaryButton, DefaultButton, Dialog, DialogType, DialogFooter } from '@fluentui/react';
import { DialogTexts } from './text';

function DialogContent(props) {
  const {
    primaryButtonCallback,
    secondaryButtonCallback,
    i18n,
  } = props;

  const titleText = i18n.getString(DialogTexts.Title);
  const bodyText = i18n.getString(DialogTexts.Body);
  const learnMoreText = i18n.getString(DialogTexts.LearnMore);
  const primaryText = i18n.getString(DialogTexts.Primary);
  const secondaryText = i18n.getString(DialogTexts.Secondary);

  const onPrimaryButtonClick = useCallback(() => primaryButtonCallback(), [primaryButtonCallback]);
  const onSecondaryButtonClick = useCallback(() => secondaryButtonCallback(), [secondaryButtonCallback]);

  return (
    <div className="uncheck-conversion-dialog-content">
      <div className="title">
        <h3>{titleText}</h3>
      </div>
      <div className="ms-Dialog-header">
        {`${bodyText} `}
        <Link href="https://help.ads.microsoft.com/#apex/ads/en/56920/2" target="_blank">{learnMoreText}</Link>
      </div>
      <DialogFooter>
        <PrimaryButton
          id="uncheck-conversion-dialog-confirm"
          onClick={onPrimaryButtonClick}
          text={primaryText}
        />
        <DefaultButton
          id="uncheck-conversion-dialog-cancel"
          onClick={onSecondaryButtonClick}
          text={secondaryText}
        />
      </DialogFooter>
    </div>
  );
}

DialogContent.defaultProps = {
  primaryButtonCallback: _.noop,
  secondaryButtonCallback: _.noop,
};
DialogContent.propTypes = {
  primaryButtonCallback: PropTypes.func,
  secondaryButtonCallback: PropTypes.func,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

// a blocking non-draggable fabric dialog to confirm user choice for not including conversion dialog
function UncheckConversionDialogRaw(props) {
  const {
    i18n,
    shouldShowDialog,
    checkIncludeCallback,
    uncheckIncludeCallback,
  } = props;

  const onDismiss = useCallback(() => {
    uncheckIncludeCallback();
  }, [uncheckIncludeCallback]);

  const primaryButtonCallback = useCallback(() => {
    checkIncludeCallback();
  }, [checkIncludeCallback]);

  const secondaryButtonCallback = useCallback(() => {
    uncheckIncludeCallback();
  }, [uncheckIncludeCallback]);

  return (
    <Dialog
      hidden={!shouldShowDialog}
      onDismiss={onDismiss}
      dialogContentProps={{
        type: DialogType.close, // with x close button in the upper-right corner
      }}
      maxWidth={460}
      minWidth={460}
      modalProps={{
        isBlocking: true,
        dragOptions: undefined, // non-dragable
      }}
    >
      <DialogContent
        primaryButtonCallback={primaryButtonCallback}
        secondaryButtonCallback={secondaryButtonCallback}
        i18n={i18n}
      />
    </Dialog>
  );
}

UncheckConversionDialogRaw.defaultProps = {
  shouldShowDialog: false,
  checkIncludeCallback: _.noop,
  uncheckIncludeCallback: _.noop,
};
UncheckConversionDialogRaw.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  shouldShowDialog: PropTypes.bool,
  checkIncludeCallback: PropTypes.func,
  uncheckIncludeCallback: PropTypes.func,
};

export const UncheckConversionDialog = _.compose(withI18nConsumer)(UncheckConversionDialogRaw);
